<template>
  <div>
    <div class="flex" >
      <v-text-field
        id="countryCode"
        class="input-field countrycode-input focused-border"
        outline
        height="48"
        :aria-label="messages.countryInputLabel"
        v-model="countryCode"
        :disabled="localReadOnly"
        :hide-details="localReadOnly ? true: false"
        type="tel"
        v-if="showAutocomplete"
        :aria-required="field.m === 1 ? true: false"
        :rules="field.m === 1 ? [countryCodeRequired] : [false]"
      >
        <div :for="countryCode" slot="label">{{messages.countryInputLabel}}</div>
      </v-text-field>
      <v-text-field
        class="input-field phone-input focused-border"
        :append-icon="codeVerified? 'check' : ''"
        :rules="field.m === 1 ? [requiredRules, phoneRules] : [phoneRules]"
        :id="field.name"
        outline
        height="48"
        :aria-label="label"
        v-model="mobileNumber"
        :disabled="localReadOnly"
        :hide-details="localReadOnly ? true: false"
        :aria-required="field.m === 1 ? true: false"
        type="tel"
      >
        <div :for="field.name" slot="label">{{messages[field.name]}}</div>
      </v-text-field>
    </div>
    <v-btn
      :ripple="false"
      v-if="!codeVerified && configuration.sendConfirm"
      :disabled="loading || !mobileNumber && !field.number || !phoneChecked"
      flat
      class="phone-verification-btn"
      @click="delay"
    >
      <div v-if="!loading">{{messages.contactDetailsContentMobileVerificationBtnText}}</div>
      <v-progress-circular role="progressbar" indeterminate color="white" v-else></v-progress-circular>
    </v-btn>
    <v-dialog
      role="dialog"
      v-model="codeVerificationDialog"
      max-width="450"
      v-if="!codeVerified"
      @keydown.esc="codeVerificationDialog=false"
      @keydown.enter="verifyCode"
    >
      <v-card>
        <v-card-title class="headline dialog-title">
          <v-spacer></v-spacer>
          <v-btn :ripple="false" icon @click.native="codeVerificationDialog = false">
            <v-icon color="white" :aria-label="messages.ariaCloseDialog">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            ref="codeInput"
            class="focused-border"
            outline
            autofocus
            height="48"
            :messages="showCounter"
            id="verification-code"
            v-model="userCodeInput"
            :error="codeVerificationRules.enabled"
            :error-messages="codeVerificationRules.errorMessage"
          >
            <div for="verification-code" slot="label">{{messages.verifyCodeDialogLabel}}</div>
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn id="sendCode"
            :ripple="false"
            flat
            class="cancel send-verification-btn"
            @click.native="delay"
            :disabled="isResendDisabled"
          >{{messages.sendVerificationCodeAgain}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            flat
            :ripple="false"
            class="edit send-verification-btn"
            :disabled="!isPinOk"
            @click.native="verifyCode"
          >{{messages.verifyCodeButton}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RestService from '../services/restService'
import { mapState } from 'vuex'
// import { parsePhoneNumberFromString as parsePhone} from 'libphonenumber-js'
import { parsePhoneNumberFromString as parsePhone } from 'libphonenumber-js/max'

export default {
  name: 'PhoneField',
  props: [
    'field',
    'readOnly',
    'showAutocomplete',
    'showAppointments',
    'email',
    'services',
    'date',
    'time'
  ],
  mixins: [RestService],
  data: () => ({
    localReadOnly: null,
    loading: false,
    regexPhone: '',
    selectedCountry: {},
    isLoading: false,
    search: null,
    allCountries: [],
    itemText: 'name',
    items: [],
    label: '',
    phoneRules: false,
    phoneChecked: false,
    requiredRules: false,
    countryCodeRequired: false,
    codeVerificationRules: {
      enabled: false,
      errorMessage: []
    },
    mobileNumber: '',
    countryCode: '',
    formattedPhone: '',
    codeVerificationDialog: false,
    codeVerified: false,
    codeSent: false,
    userCodeInput: null,
    existingAppointments: [],
    countryCodeMemory: '',
    mobileNumberMemory: ''
  }),
  watch: {
    selectedCountry (country) {
      if (this.funcDebug) console.log('PhoneField:watch:selectedCountry')
      if (country) {
        this.countryCode = country.callingCodes[0]
        if (!this.configuration.sendConfirm && this.mobileNumber.length > 0) {
          this.pushFormattedPhone()
        }
      }
    },
    mobileNumber () {
      if (this.funcDebug) console.log('PhoneField:watch:mobileNumber')
      if (!this.configuration.sendConfirm && this.mobileNumber.length > 0) {
        this.pushFormattedPhone()
      }
    },
    countryCode () {
      if (this.funcDebug) console.log('PhoneField:watch:countryCode')
      if (this.countryCode.charAt(0) === '0') { this.countryCode = this.countryCode.substr(1) }
      if (this.countryCode.charAt(0) === '0') { this.countryCode = this.countryCode.substr(1) }
      if (this.countryCode.charAt(0) !== '+') { this.countryCode = '+' + this.countryCode }
      this.revalidateMobileNumber()
    }

  },
  computed: {
    ...mapState([
      'configuration',
      'messages',
      'funcDebug',
      'defaultCountryPrefix'
    ]),
    isPinOk () {
      return this.userCodeInput != null && this.userCodeInput.length === parseInt(this.configuration.confirmDigits)
    },
    showCounter () {
      var counter = ''
      if (this.userCodeInput == null) { counter += '0/' } else { counter += this.userCodeInput.length + '/' }
      counter += this.configuration.confirmDigits
      return counter
    },
    isResendDisabled () {
      return this.codeSent
    }
  },
  methods: {
    /* customFilter (item, queryText, itemText) {
      if (queryText && queryText.charAt(0) === '+' && queryText.length >= 1) {
        queryText = queryText.substr(1).toString()
      }
      if ((item.name.toLowerCase().indexOf(queryText.toLowerCase()) > -1) || (item.callingCodes[0].indexOf(queryText) > -1)) {
        return item
      }
    }, */
    pushFormattedPhone () {
      if (this.funcDebug) console.log('PhoneField:method:pushFormattedPhone')
      let isValid = false
      let completePhoneToCheck = this.mobileNumber.replace(/^0+/, '')
      // add country code
      completePhoneToCheck = this.countryCode + completePhoneToCheck
      if (this.configuration.usePhoneLib && this.configuration.usePhoneLib === true) {
        let testPhone = null
        testPhone = parsePhone(completePhoneToCheck)
        // if undefined, then not recognized then invalid
        if (testPhone) {
          isValid = testPhone.isValid()
        }
      } else {
        isValid = this.regexPhone.test(completePhoneToCheck)
      }
      if (isValid) {
        this.formattedPhone = completePhoneToCheck.substr(1)
        if (this.funcDebug) console.log('Emit (phone-verified): ' + this.formattedPhone)
        this.$emit(
          'phone-verified',
          true,
          this.formattedPhone,
          this.mobileNumber,
          null,
          false
        )
      }
    },
    delay () {
      this.codeSent = true

      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.codeSent = false
      }, 5000)
      this.sendCode()
    },
    beforeDestroy () {
      // clear the timeout before the component is destroyed
      clearTimeout(this.timeout)
    },
    sendCode () {
      if (this.funcDebug) console.log('PhoneField:method:sendCode')
      this.loading = true

      var _this = this
      this.codeVerificationRules.enabled = false
      this.userCodeInput = null
      this.codeVerificationRules.errorMessage = []
      if (!this.localReadOnly) {
        let completePhoneToCheck = this.mobileNumber.replace(/^0+/, '')
        // add country code
        completePhoneToCheck = this.countryCode + completePhoneToCheck
        this.formattedPhone = completePhoneToCheck.substr(1)
      } else {
        this.formattedPhone = this.field.number
      }
      this.sendVerificationCode(this.formattedPhone).then(response => {
        if (response.data.message === 'error.verify.too.many') {
          _this.codeVerificationRules.errorMessage = _this.messages.verificationCodeTooMany
        }
        _this.codeVerificationDialog = true
        _this.$nextTick(() => {
          _this.$refs.codeInput.$refs.input.focus()
        })
        _this.loading = false
      })
    },
    verifyCode () {
      if (this.funcDebug) console.log('PhoneField:method:verifyCode')
      var _this = this
      this.verifyPhoneNumber(this.userCodeInput, this.formattedPhone).then(
        response => {
          if (response.status === 200 && response.data.message === 'ok') {
            _this.codeVerificationDialog = false
            _this.codeVerified = true
            _this.localReadOnly = true
            if (_this.showAppointments) {
              _this.checkRestrictions(_this.formattedPhone, _this.email, _this.services, _this.date, _this.time).then(response => {
                if (_this.funcDebug) console.log('Emit (phone-verified): ' + _this.formattedPhone)
                _this.$emit(
                  'phone-verified',
                  _this.codeVerified,
                  _this.formattedPhone,
                  _this.mobileNumber,
                  response.data,
                  _this.localReadOnly
                )
              })
            } else {
              if (_this.funcDebug) console.log('Emit (phone-verified): ' + _this.formattedPhone)
              _this.$emit(
                'phone-verified',
                _this.codeVerified,
                _this.formattedPhone,
                _this.mobileNumber,
                _this.localReadOnly
              )
            }
          } else {
            _this.codeVerificationRules.enabled = true
            _this.codeVerificationRules.errorMessage = _this.messages.verificationCodeError
          }
        }).catch(error => {
        _this.codeVerificationRules.errorMessage = error.response.status + ' error - ' + error.response.statusText
      })
    },
    revalidateMobileNumber () {
      var _this = this
      if (this.funcDebug) console.log('PhoneField:method:revalidateMobileNumber')
      this.mobileNumberMemory = this.mobileNumber
      this.mobileNumber = ''
      setTimeout(() => {
        _this.mobileNumber = _this.mobileNumberMemory
      }, 100)
    }
  },
  mounted () {
    if (this.funcDebug) console.log('PhoneField:mounted')
    var _this = this
    this.localReadOnly = this.readOnly
    if (!this.localReadOnly) {
      this.getCountry(this.defaultCountryPrefix).then(response => {
        _this.selectedCountry = response.data
        _this.items.push(_this.selectedCountry)
        _this.countryCode = response.data.callingCodes[0]
        _this.label = _this.messages[_this.field.name]
      })
      /* this.getAllCountries().then(response => {
        _this.allCountries = response.data
      }) */
      this.regexPhone = new RegExp(this.configuration.regexPhone)
      this.requiredRules = v => !!v || _this.messages.fieldRequired === undefined ? false : _this.messages.fieldRequired
      this.phoneRules =
        v => {
          if (v && v.length > 0) {
            // if it starts with a + it's invalid
            if (v.charAt(0) === '+') {
              _this.phoneChecked = false
            } else {
              // remove leading 0
              let completePhoneToCheck = v.replace(/^0+/, '')
              // add country code
              completePhoneToCheck = this.countryCode + completePhoneToCheck
              // phone library
              if (_this.configuration.usePhoneLib && _this.configuration.usePhoneLib === true) {
                let testPhone = null
                testPhone = parsePhone(completePhoneToCheck)
                // if undefined, then not recognized then invalid
                if (testPhone) {
                  _this.phoneChecked = testPhone.isValid()
                } else {
                  _this.phoneChecked = false
                }
              } else {
                // regex
                _this.phoneChecked = _this.regexPhone.test(completePhoneToCheck)
              }
            }
            return _this.phoneChecked || _this.messages.invalidPhone === undefined ? false : _this.messages.invalidPhone
          } else {
            return false
          }
        }
      this.countryCodeRequired = v => {
        return (v && v.length > 1) || _this.messages.fieldRequired === undefined ? false : _this.messages.fieldRequired
      }
    } else {
      this.label = '+' + this.field.number
      this.mobileNumber = this.field.number
      this.phoneChecked = true
    }
  }
}
</script>
<style lang="scss">

</style>
